import useStrings from "../../localization/useStrings"
import useQueryParams from "../../hooks/useQueryParams"
import useHasPro from "../../hooks/useHasPro"
import { usePurchase } from "../../context/purchaseContext"

export const useExpirationStrings = () => {
  const { bubbleExpiration: strings } = useStrings()
  const {
    showUltimateInExpiration,
    isSubscriptionExpiration,
    alternateStep2Subtitle,
  } = useQueryParams()
  const hasPro = useHasPro()
  const { state: purchaseState } = usePurchase()

  const isUltimate = purchaseState.ultimateSelected

  const getExpiredTitle = () => {
    if (!hasPro && !isSubscriptionExpiration) {
      return strings.expiredTitle
    }
    return isUltimate
      ? strings.ultimateExpiredTitle
      : strings.premiumExpiredTitle
  }

  const getStep1Subtitle = () => {
    if (hasPro) {
      return strings.renewSubtitle
    }
    if (!showUltimateInExpiration) {
      return strings.expiredSubtitle
    }
    return isUltimate
      ? strings.expiredSubtitleUltimate
      : strings.expiredSubtitlePremium
  }

  const getStep2Subtitle = () => {
    if (alternateStep2Subtitle) {
      return strings.selectPlanOrSwitchToBasic
    }
    return strings.selectPlan
  }

  const expiredTitle = getExpiredTitle()

  return {
    step1: {
      title: expiredTitle,
      subtitle: getStep1Subtitle(),
    },
    step2: {
      title: expiredTitle,
      subtitle: getStep2Subtitle(),
      basicSectionTitle: hasPro ? strings.proTitle : strings.basicTitle,
      basicSectionBadge: hasPro ? strings.purchased : strings.free,
      basicSectionDescription: hasPro
        ? strings.proDescription
        : strings.basicDescription,
      basicSectionCta: hasPro ? strings.switchToPro : strings.switchToBasic,
    },
  }
}
